import Secretary from './components/technology/entries/Secretary'
import Cosital18 from './components/technology/entries/Cosital18'
import Training from './components/technology/entries/Training'
import Localis from './components/technology/entries/Localis'
import Cnis19 from './components/technology/entries/Cnis19'
import Cnis18 from './components/technology/entries/Cnis18'
import Administration from './components/Administration'
import Certifications from './components/Certifications'
import Transcription from './components/Transcription'
import { CookieManager } from "react-cookie-manager"
import Publications from './components/Publications'
import "bootstrap-icons/font/bootstrap-icons.css"
import { Route, Routes, Navigate } from 'react-router-dom'
import Technology from './components/Technology'
import Header from './components/header/Header'
import Citizens from './components/Citizens'
import Services from './components/Services'
import Videoact from './components/Videoact'
import Privacy from './components/Privacy'
import Contact from './components/Contact'
import Cookies from './components/Cookies'
import Publish from './components/Publish'
import Record from './components/Record'
import Footer from './components/Footer'
import "react-cookie-manager/style.css"
import Legal from './components/Legal'
import Press from './components/Press'
import Main from './components/Main'
import Us from './components/Us'
import './App.css'

function App() {

  return (
    <CookieManager
    enableFloatingButton={true}
      disableAutomaticBlocking={true}
      translations={{
        title: "Preferencias de Cookies",
        message: "Valoramos tu privacidad. Utilizamos cookies para mejorar tu experiencia de uso. Elige las cookies que deseas permitir.",
        buttonText: "Aceptar todas",
        declineButtonText: "Declinar todas",
        manageButtonText: "Administrar cookies",
        privacyPolicyText: "Política de privacidad",
        manageTitle: "Preferencias de cookies",
        manageMessage: "A continuación puedes administrar tus preferencias de cookies. Las cookies esenciales siempre están habilitadas, ya que son necesarias para que el sitio web funcione correctamente.",
        manageEssentialTitle: "Esenciales",
        manageEssentialSubtitle: "Necesarias para que el sitio web funcione correctamente",
        manageEssentialStatus: "Estado: Siempre habilitado",
        manageEssentialStatusButtonText: "Siempre activo",
        manageAnalyticsTitle: "Analytics",
        manageAnalyticsSubtitle: "Ayúdanos a entender cómo los visitantes interactúan con nuestro sitio web",
        manageSocialTitle: "Social",
        manageSocialSubtitle: "Habilitar funciones de redes sociales y compartir",
        manageAdvertTitle: "Anuncios",
        manageAdvertSubtitle: "Personalizar anuncios y medir su rendimiento",
        manageCookiesStatus: "Estado: {{status}} el {{date}}",
        manageCookiesStatusConsented: "Consentido",
        manageCookiesStatusDeclined: "Rechazado",
        manageCancelButtonText: "Cancelar",
        manageSaveButtonText: "Guardar preferencias"
      }}
      showManageButton={true}
      privacyPolicyUrl="/politica-de-privacidad/"
      theme="light"
      displayType="banner"
      cookieKitId=""
      onManage={() => {
        window.location.reload()
      }}
      onAccept={() => {
        window.location.reload()
      }}
      onDecline={() => {
        window.location.reload()
      }}
    >
      <div className="flex col sbetween acenter">

        <Header />
        <Routes>

          <Route path="/seneca-facilita-trabajo-secretarios-generando-video-actas/" element={<Secretary />} />
          <Route path="/seneca-grabacion-plenos-y-realizacion-video-actas-cnis-2018/" element={<Cnis18 />} />
          <Route path="/seneca-retransmite-congreso-cosital-2018-gijon/" element={<Cosital18 />} />
          <Route path="/seneca-volvera-a-estar-presente-en-el-cnis-2019/" element={<Cnis19 />} />
          <Route path="/seneca-presente-en-el-i-congreso-red-localis/" element={<Localis />} />
          <Route path="/seneca/departamento-de-publicaciones/" element={<Publications />} />
          <Route path="/funcionalidades/grabacion-y-catalogacion/" element={<Record />} />
          <Route path="/funcionalidades/administracion/" element={<Administration />} />
          <Route path="/funcionalidades/transcripcion/" element={<Transcription />} />
          <Route path="/funcionalidades/publicacion/" element={<Publish />} />
          <Route path="/seneca/prensa-y-comunicacion/" element={<Press />} />
          <Route path="/cosital/" element={<Navigate to="/" replace />} />
          <Route path="/resultados-encuesta-cosital/" element={<Navigate to="/" replace />} />
          <Route path="/politica-de-privacidad/" element={<Privacy />} />
          <Route path="/certificaciones/" element={<Certifications />} />
          <Route path="/seneca/ciudadanos/" element={<Citizens />} />
          <Route path="/formacion-seneca/" element={<Training />} />
          <Route path="/seneca/empresas/" element={<Navigate to="/" replace />} />
          <Route path="/tecnologia/" element={<Technology />} />
          <Route path="/video-acta/" element={<Videoact />} />
          <Route path="/servicios/" element={<Services />} />
          <Route path="/contacto/" element={<Contact />} />
          <Route path="/cookies/" element={<Cookies />} />
          <Route path="/conocenos/" element={<Us />} />
          <Route path="/legal/" element={<Legal />} />
          <Route path="/" element={<Main />} />

        </Routes>
        <Footer></Footer>

      </div>
    </CookieManager>
  )
}

export default App
